import { useState, useEffect } from "react";

export function useUserMedia() {
    const [mediaStream, setMediaStream] = useState<MediaStream | null>(null);

    useEffect(() => {
        async function enableStream() {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({
                    audio: false,
                    video: {
                        facingMode: "environment",
                        width:1280,
                        height:720,
                    }
                });
                setMediaStream(stream);
            } catch(err) {
                console.log(err); 
            }
        }

        if (!mediaStream) {
            enableStream();
        } else {
            return function cleanup() {
                        // mediaStream.getTracks().forEach(track => {
                        //     track.stop();
                        // })
            }
        }
    }, [mediaStream]);

    return mediaStream;
};